import { Events } from '@type-r/models';
import { Linked, useLinked } from '@type-r/react';
import { InlineTable, navigate, PopupIODialog, TableCell, TableHeader } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, PlatformCompany, RelationshipModel } from 'api';
import { UnresolvedRemittanceAdvice } from '../../api/unresolvedRemittanceAdvice';

export const ResolveRemittanceAdviceDialog = ({ $resolving, remittanceAdvice, customer, supplier } : {
    $resolving : Linked<boolean>,
    remittanceAdvice : UnresolvedRemittanceAdvice,
    customer : PlatformCompany,
    supplier : PlatformCompany
}) => {
    const $resolvedCount = useLinked( 0 );

    return (
        <PopupIODialog
            $isOpen={ Linked.value( $resolving.isTruthy, x => !x ? $resolving.null() : undefined ) }
            title="Resolve Remittance Advice"
            actionLabel="Resolve"
            width={800}
            success={
                <p>
                    { $resolvedCount.value } Remittance advice were resolved.
                </p>
            }
            doIO={ async () => {
                $resolvedCount.set( await remittanceAdvice.resolveAll( supplier.id, customer.id, remittanceAdvice.id ) );
            }}

            onSuccess={() => {
                Events.trigger( "raSummary:refresh" );
                navigate(`remittance-advices/unmatched/${remittanceAdvice.id}`);
            }
            }
        >
            <p>Companies info will be updated.</p>
            
            <InlineTable>
                <TableHeader>
                    <TableCell/>
                    <TableCell>{supplier.name}</TableCell>
                    <TableCell>{customer.name}</TableCell>
                </TableHeader>
            </InlineTable>
            <p> Selected remittance advice will be resolved.</p>
        </PopupIODialog>
    )
}